import type { ShopifyProductResponse, Store } from 'pages/Integrations/Shopify/types';
import type { BasicSuccessResponse, HTTPFunctions } from '../types';
import type { WooCommerceProductsResponse, WooCommerceStore, WooCommerceStoreRequest } from 'pages/Integrations/WooCommerce/types';
import type { MagentoProductsResponse, MagentoStore } from 'pages/Integrations/Magento/types';

const getUrlInShopifyProducts = (storeId: string, limit: number, cursor: string) => {
  const url = `/spf/products/${storeId}/?limit=${limit}`;
  if (!cursor) return url;
  return `${url}&cursor=${cursor}`;
};

const integrations = ({ get, del, put, post }: HTTPFunctions) => ({
  getShopifyStores: () => get<Store[]>('/spf/store/'),
  removeShopifyStore: (storeId: string) => del<BasicSuccessResponse>(`/spf/store/${storeId}`),
  getGAReport: (email: string, property: string, year: number, month: number) => get<(string | null)[][]>(`/ga/reports/summary/${encodeURIComponent(email)}/${property}/${year}/${month}/`),
  getShopifyProducts: (storeId: string, limit: number, cursor: string) =>
    get<ShopifyProductResponse>(getUrlInShopifyProducts(storeId, limit, cursor)),
  updateShopifyProduct: (storeId: string, productId: string, name: string, description: string) =>
    put<BasicSuccessResponse>(`/spf/products/${storeId}/${productId}`, {name, description}),
  getWooCommerceStores: () => get<WooCommerceStore[]>('/woo/store/'),
  getWooCommerceProducts: (storeId: string, page: number, pageSize: number = 10) => get<WooCommerceProductsResponse>(`/woo/products/${storeId}/?page=${page}&page_size=${pageSize}`),
  updateWooCommerceProduct: (storeId: string, productId: number, name: string, description: string) =>
    put<BasicSuccessResponse>(`/woo/products/${storeId}/${productId}`, {name, description}),
  removeWooCommerceStore: (storeId: string) => del<BasicSuccessResponse>(`/woo/store/${storeId}`),
  addWooCommerceStore: (store: WooCommerceStoreRequest) =>
    post<WooCommerceStore>('/woo/store/', { url: store.url, consumer_key: store.key, consumer_secret: store.secret }),
  getMagentoStores: () => get<MagentoStore[]>('/magento/store/'),
  getMagentoProducts: (storeId: string, page: number, pageSize: number = 10) => get<MagentoProductsResponse>(`/magento/products/${storeId}/?page=${page}&page_size=${pageSize}`),
  updateMagentoProduct: (storeId: string, sku: string, name: string, attribute_set_id: number) =>
    put<BasicSuccessResponse>(`/magento/products/${storeId}/${sku}`, {name, attribute_set_id}),
  removeMagentoStore: (storeId: string) => del<BasicSuccessResponse>(`/magento/store/${storeId}`)
});

export default integrations;
